import { render } from "./Edit.vue?vue&type=template&id=704bd4cc"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
script.render = render

export default script